import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AppService, getStepRoute, Host, Menu} from "../../../../../common";
import {Cart, CartService} from "../../../../../common";
import {Subscription} from "rxjs";
import {Location} from "@angular/common";

@Component({
  selector: 'address-entry',
  standalone: false,
  templateUrl: './address-entry.html'
})
export class AddressEntryPage implements OnInit, OnDestroy {

  cart: Cart;
  menu: Menu;
  host: Host;
  form: FormGroup;

  private subscriptions: Array<Subscription> = new Array<Subscription>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private appService: AppService,
    private cartService: CartService,
    private formBuilder: FormBuilder,
    private location: Location
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.appService.load().subscribe(({host, menu, table, cart}) => {
        this.host = host;
        this.menu = menu;
        this.cart = cart;

        this.form = this.formBuilder.group({
          name: [cart.address.name, [Validators.required, Validators.minLength(2)]],
          phone: [cart.address.phone, (host.require_delivery_phone)?Validators.required:null],
          email: [cart.address.email, (host.require_delivery_email)?[Validators.required, Validators.email]:Validators.email],
          notes: [cart.address.notes]
        });

        this.subscriptions.push(this.form.valueChanges.subscribe((value) => {
          if (this.form.valid) {
            this.cart.address.name = value.name;
            this.cart.address.email = value.email;
            this.cart.address.phone = value.phone;
            this.cart.address.notes = value.notes;
          }
        }));
      })
    )
  }

  ngOnDestroy(): void {
    let sub = null;
    while(sub = this.subscriptions.pop()) {
      sub.unsubscribe();
    }
  }

  scrollIntoView($event) {
    $event.target.scrollIntoView(true);
  }

  back() {
    this.location.back()
  }

  canProceed(): boolean {
    return this.form.valid && this.appService.getOrdersEnabled();
  }

  getNextStep() {
    return this.cart.getNextCheckoutStep();
  }

  next() {
    if (this.canProceed()) {
      // this.appService.saveAddressToStorage(address);
      this.cart.save()
      this.router.navigate(getStepRoute(this.getNextStep()))
    }
    return false;
  }

}
